import React from 'react';

const InactiveFolderIcon = ({ width = 20, height = 20, color = '#454550' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5L9 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V7C18 5.89543 17.1046 5 16 5H11ZM8.17157 5H4V15H16V7H10.1716L8.17157 5Z"
      fill={color}
    />
  </svg>
);

export default InactiveFolderIcon;
